import { __extends } from "tslib";
import { deepMix, every, some } from '@antv/util';
import { Plot } from '../../core/plot';
import { DualAxesGeometry } from './types';
import { adaptor } from './adaptor';

var DualAxes =
/** @class */
function (_super) {
  __extends(DualAxes, _super);

  function DualAxes() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型: 双轴图 */


    _this.type = 'dual-axes';
    return _this;
  }
  /**
   * 获取 双轴图 默认配置
   */


  DualAxes.prototype.getDefaultOptions = function (options) {
    var _a;

    var _b = options.geometryOptions,
        geometryOptions = _b === void 0 ? [] : _b,
        xField = options.xField;
    var hasColumn = some(geometryOptions, function (_a) {
      var geometry = _a.geometry;
      return geometry === DualAxesGeometry.Column;
    });
    var allLine = every(geometryOptions, function (_a) {
      var geometry = _a.geometry;
      return geometry === DualAxesGeometry.Line || geometry === undefined;
    });
    return deepMix({}, _super.prototype.getDefaultOptions.call(this, options), {
      yAxis: [],
      geometryOptions: [],
      meta: (_a = {}, _a[xField] = {
        // x 轴一定是同步 scale 的
        sync: true,
        // 如果有没有柱子，则
        range: allLine ? [0, 1] : undefined
      }, _a),
      tooltip: {
        showMarkers: allLine,
        // 存在柱状图，不显示 crosshairs
        showCrosshairs: !hasColumn,
        shared: true,
        crosshairs: {
          type: 'x'
        }
      },
      interactions: hasColumn ? [{
        type: 'legend-visible-filter'
      }, {
        type: 'active-region'
      }] : [{
        type: 'legend-visible-filter'
      }],
      syncViewPadding: true
    });
  };
  /**
   * 获取双轴图的适配器
   */


  DualAxes.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return DualAxes;
}(Plot);

export { DualAxes };